import React from 'react';
import { TrackingCtx, combineEvent, trackEvent }  from  "../tracking"

export function WithTracking(Component) {
    return React.forwardRef((props, ref) => {
        const trackableClick = (ctxTracking) => () => {
            if (!props.onClick) {
                return;
            }
            if (props.tracking) {
                trackEvent(combineEvent(props.tracking, ctxTracking))
            }
            props.onClick(...arguments);
        }
        return (
            <TrackingCtx.Consumer>
             {tracking => (
                <Component {...props}  ref={ref} onClick={trackableClick(tracking)}>{props.children}</Component>
             )}    
             </TrackingCtx.Consumer>
        );
    });
}

